import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=9de5683a&scoped=true"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de5683a",
  null
  
)

export default component.exports